import React from 'react';
import PropTypes from 'prop-types';
import WithHover from 'WithHover';


const ImageButton = (props) => {
  const altHover = props.altHover || props.alt;
  const srcHover = props.srcHover || props.src;
  const styleHover = props.styleHover || props.style;

  const alt = props.isHover ? altHover : props.alt;
  const src = props.isHover ? srcHover : props.src;
  const style = props.isHover ? styleHover : props.style;

  const imgStyle = props.noMargin ? { margin: 0 } : {};

  return (
    <button
      className={props.className}
      disabled={props.disabled}
      onClick={props.onClick}
      onMouseOver={props.onMouseOver}
      onMouseOut={props.onMouseOut}
      style={style}
    >
      <img
        alt={alt}
        src={src}
        style={imgStyle}
      />
    </button>
  );
};

ImageButton.defaultProps = {
  altHover: '',
  className: '',
  disabled: false,
  isHover: false,
  noMargin: true,
  onClick: null,
  srcHover: '',
  style: {},
  styleHover: null,
};

ImageButton.propTypes = {
  alt: PropTypes.string.isRequired,
  altHover: PropTypes.string,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  isHover: PropTypes.bool,
  noMargin: PropTypes.bool,
  onClick: PropTypes.func,
  onMouseOut: PropTypes.func.isRequired,
  onMouseOver: PropTypes.func.isRequired,
  src: PropTypes.string.isRequired,
  srcHover: PropTypes.string,
  style: PropTypes.shape({}),
  styleHover: PropTypes.shape({}),
};

export default WithHover(ImageButton);



// WEBPACK FOOTER //
// ./src-react/ImageButton/index.jsx